import { render, staticRenderFns } from "./att_log_deductions.vue?vue&type=template&id=4e0bf9c1&"
import script from "./att_log_deductions.vue?vue&type=script&lang=js&"
export * from "./att_log_deductions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports